import { resizeImage } from '@troverecommerce/saas-components-ts';
import type { CatalogImageFieldProps } from '@src/types';

// Custom image field component that displays the main image URL
const CatalogImageField = ({ record }: CatalogImageFieldProps) => {
  if (!record?.mainImageUrl) {
    return (
      <div style={{
        width: 60,
        height: 60,
        backgroundColor: '#f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '10px'
      }}>
        No Image
      </div>
    );
  }

  // Use resizeImage to optimize and transform the image URL for Cloudinary
  const imageUrl = resizeImage(record.mainImageUrl, 800);

  return (
    <img
      src={imageUrl}
      alt={record.title || 'Product image'}
      style={{
        width: 60,
        height: 60,
        objectFit: 'cover',
        borderRadius: 4
      }}
      onError={(e) => {
        console.error('Image failed to load:', imageUrl, 'Original:', record.mainImageUrl);
        // Hide image if it fails to load
        (e.target as HTMLImageElement).style.display = 'none';
      }}
    />
  );
};

export default CatalogImageField;
